export const PreferredCountries: string[] = ['BR', 'US'];
